<template>

    <v-dialog 
    v-model="form.show"
    width="500">
    <v-card hover class="card-round pa-3">
      <v-layout justify-center="">
        <v-flex xs8> 
          <v-form v-model="valid">
          <p class="subheading text-center pa-3"> Nieuw template formulier</p>
          <v-text-field 
            v-model="form.name"
            :rules="rules"
            label="Naam"
            required=""
            ></v-text-field>
          <v-textarea 
          v-model="form.description"
          label="Omschrijving"
          >

          </v-textarea>
          </v-form>
        </v-flex>
      </v-layout>
      

      <v-layout justify-space-around>
        <v-flex xs4 class="text-center">
            <v-btn block rounded color="error" @click="form.show = false" >Annuleren</v-btn>
        </v-flex>
        <v-flex xs4 class="text-center">
            <v-btn block rounded color="success" :disabled="!valid" @click="newFormTemplate()" >Aanmaken</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>    

</template>


<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      valid: false,
      rules: [v => !!v || "Verplicht veld"]
    };
  },
  computed: {
    ...mapState(["archive", "app", "form"])
  },
  methods: {
    ...mapMutations(["closeArchiveDialog"]),
    newFormTemplate() {
      this.$store.dispatch("newFormTemplate");

      this.$store.state.form.show = false;
    }
  }
};
</script>

<style scoped>
.card-round {
  min-height: 100px;
}
</style>


